export default __webpack_public_path__ + "static/media/banner_home2.24db78a3.jpg";